import Seta from '@assets/images/Seta.svg';
import PlaceholderImage from '@assets/images/img-final-home-01.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  ImageBox,
  SectionContainer,
} from './AuditOne.style';
import { useTranslation } from 'react-i18next';

const AuditOne = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditOne.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <div className="text-content">
            <p>{t('auditOne.paragraphOne')}</p>
          </div>
        </TextBox1>
        <ImageBox>
          <img src={PlaceholderImage} alt="Imagem" />
        </ImageBox>
        <TextBox2>
          <p>{t('auditOne.paragraphTwo')}</p>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditOne;
